import { useTranslation } from 'react-i18next';
import { HowToInterpretContainer, InfoIcon, ModalContentWrapper, PestPressureLabel } from './info-modal.style';
import { RiskLevelBadges } from './risk-level-badges.component';

export const OverviewModalContent = () => {
  const [t] = useTranslation();

  return (
    <ModalContentWrapper>
      <p>
        <strong>{t('pages.regional_overview.regional_risk.tabs.modal.overview.product_name')}</strong>{' '}
        {t('pages.regional_overview.regional_risk.tabs.modal.overview.intro')}
      </p>

      <p>{t('pages.regional_overview.regional_risk.tabs.modal.overview.predictions_info')}</p>

      <p>{t('pages.regional_overview.regional_risk.tabs.modal.overview.risk_levels_intro')}</p>

      <PestPressureLabel>{t('pages.regional_overview.regional_risk.tabs.modal.overview.pest_pressure_label')}</PestPressureLabel>

      <RiskLevelBadges />

      <HowToInterpretContainer>
        <InfoIcon />
        <strong>{t('pages.regional_overview.regional_risk.tabs.modal.overview.how_to_interpret')}</strong>
      </HowToInterpretContainer>

      <p>{t('pages.regional_overview.regional_risk.tabs.modal.overview.interpretation_text')}</p>
    </ModalContentWrapper>
  );
};
